import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { useIntl } from 'react-intl';

import { userHasFeature } from '../../helpers/Features';
import { getSetting } from '../../helpers/Settings';

import PoweredBy from '../PoweredBy';

const PageFooter = ({ selectedFiles, selectedCollections }) => {
  const intl = useIntl();

  const hideBranding = (userHasFeature('hide-stockpress-branding-custom-pages') && getSetting('hide_stockpress_branding_custom_pages'));

  if (hideBranding && !getSetting('cs1')) {
    return null;
  }

  if (getSetting('cs1')) {
    return (
      <div className="landing-footer">
        <Container>
          <div className="landing-footer-content">
            {!hideBranding && (
            <div className="landing-footer-logo">
              <a href="https://stockpress.co/" target="_blank" rel="noopener noreferrer">
                <span>{intl.formatMessage({ defaultMessage: 'Powered by' })}</span>
                <img src="/images/stockpress-brand-mark.png" alt="Stockpress" />
                <span>Stockpress</span>
              </a>
            </div>
            )}
            {getSetting('cs1') && (
            <div className="landing-footer-navigation">
              <nav className="landing-footer-page-navigation">
                <ul>
                  <li><a href="https://sites.disney.com/ngr-privacy-policy/" target="_blank" rel="noreferrer">{intl.formatMessage({ defaultMessage: 'Privacy Policy' })}</a></li>
                  <li><a href="https://disneytermsofuse.com/" target="_blank" rel="noreferrer">{intl.formatMessage({ defaultMessage: 'Terms of Use' })}</a></li>
                </ul>
              </nav>
            </div>
            )}
          </div>
        </Container>
      </div>
    );
  }

  return (
    <>
      <div className="landing-footer-space" />
      {(selectedFiles.length === 0 && selectedCollections.length === 0) && (
        <PoweredBy />
      )}
    </>
  );
};

const mapStateToProps = state => ({
  selectedFiles: state.Files.selectedFiles,
  selectedCollections: state.Collections.selectedCollections,
});

PageFooter.propTypes = {
  selectedFiles: PropTypes.array.isRequired,
  selectedCollections: PropTypes.array.isRequired,
};

export default connect(mapStateToProps)(PageFooter);
